/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAllOrgResponse
 */
export interface GetAllOrgResponse {
    /**
     * 
     * @type {string}
     * @memberof GetAllOrgResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetAllOrgResponse
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof GetAllOrgResponse
     */
    company_name: string;
    /**
     * 
     * @type {number}
     * @memberof GetAllOrgResponse
     */
    subscription_count: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllOrgResponse
     */
    ops_subscription_count: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllOrgResponse
     */
    respond_subscription_count: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllOrgResponse
     */
    ops_seats_used: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllOrgResponse
     */
    respond_seats_used: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetAllOrgResponse
     */
    is_safeguard_organization: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetAllOrgResponse
     */
    user_count: number;
}

/**
 * Check if a given object implements the GetAllOrgResponse interface.
 */
export function instanceOfGetAllOrgResponse(value: object): value is GetAllOrgResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('company_name' in value) || value['company_name'] === undefined) return false;
    if (!('subscription_count' in value) || value['subscription_count'] === undefined) return false;
    if (!('ops_subscription_count' in value) || value['ops_subscription_count'] === undefined) return false;
    if (!('respond_subscription_count' in value) || value['respond_subscription_count'] === undefined) return false;
    if (!('ops_seats_used' in value) || value['ops_seats_used'] === undefined) return false;
    if (!('respond_seats_used' in value) || value['respond_seats_used'] === undefined) return false;
    if (!('is_safeguard_organization' in value) || value['is_safeguard_organization'] === undefined) return false;
    if (!('user_count' in value) || value['user_count'] === undefined) return false;
    return true;
}

export function GetAllOrgResponseFromJSON(json: any): GetAllOrgResponse {
    return GetAllOrgResponseFromJSONTyped(json, false);
}

export function GetAllOrgResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllOrgResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'org_code': json['org_code'],
        'company_name': json['company_name'],
        'subscription_count': json['subscription_count'],
        'ops_subscription_count': json['ops_subscription_count'],
        'respond_subscription_count': json['respond_subscription_count'],
        'ops_seats_used': json['ops_seats_used'],
        'respond_seats_used': json['respond_seats_used'],
        'is_safeguard_organization': json['is_safeguard_organization'],
        'user_count': json['user_count'],
    };
}

export function GetAllOrgResponseToJSON(json: any): GetAllOrgResponse {
    return GetAllOrgResponseToJSONTyped(json, false);
}

export function GetAllOrgResponseToJSONTyped(value?: GetAllOrgResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'org_code': value['org_code'],
        'company_name': value['company_name'],
        'subscription_count': value['subscription_count'],
        'ops_subscription_count': value['ops_subscription_count'],
        'respond_subscription_count': value['respond_subscription_count'],
        'ops_seats_used': value['ops_seats_used'],
        'respond_seats_used': value['respond_seats_used'],
        'is_safeguard_organization': value['is_safeguard_organization'],
        'user_count': value['user_count'],
    };
}

